import { Error } from '@clearkit/icons';
import { CKBannerNext, CKBox, CKButton } from 'clearkit';
import { FC } from 'react';

import AuthLayout, { AuthLayoutHeader } from '~/components/layouts/AuthLayout';

import TextFieldWithValidations from '../shared/TextFieldWithValidations';
import useStartMagicLinkFlow, {
  buildErrorMessage,
  emailIsValid,
} from '../shared/useStartMagicLinkFlow';

const Login: FC = function() {
  const {
    email,
    setEmail,
    isCreatingMagicLink,
    error,
    createMagicLink,
    formHandler,
    validationErrors,
  } = useStartMagicLinkFlow();

  return (
    <AuthLayout>
      <>
        <AuthLayoutHeader
          className="sm:w-80"
          description="Enter your email address below, and we'll send you a magic link to sign in."
          header={
            <>
              <span className="font-semibold">Welcome back,&nbsp;</span>
              <span className="font-normal">
                sign in to continue to Clearbit.
              </span>
            </>
          }
        />

        <form onSubmit={formHandler}>
          <CKBox className="w-full p-6 sm:w-[440px] gap-6">
            {error && (
              <CKBannerNext variant="error">
                <CKBannerNext.IconStatus>
                  <Error />
                </CKBannerNext.IconStatus>
                <CKBannerNext.Header>
                  Whoops, something went wrong.
                </CKBannerNext.Header>
                <CKBannerNext.Body>
                  {buildErrorMessage(error)}
                </CKBannerNext.Body>
              </CKBannerNext>
            )}

            <TextFieldWithValidations
              name="email_address"
              onChange={setEmail}
              placeholder="Email address"
              type="email"
              validationErrors={validationErrors}
              value={email}
            />
            <CKButton
              className="self-start"
              isDisabled={!emailIsValid(email)}
              isLoading={isCreatingMagicLink}
              onClick={createMagicLink}
              variant="bold"
              variantColor="blue"
            >
              Send me a sign in link
            </CKButton>
          </CKBox>
        </form>

        <div>
          <div className="text-sm text-center text-gray-600">
            <span>Trouble signing in?</span>
            <a
              className="pl-2 font-medium text-blue-600 hover:text-blue-500"
              href="https://help.clearbit.com/hc/en-us/articles/18895106621463-How-to-log-in-to-Clearbit"
            >
              Check out our Help Center article
            </a>
          </div>
        </div>
      </>
    </AuthLayout>
  );
};

export default Login;
